import styled from 'styled-components';
import { lineHeight, inputWidth } from '../style';

export type InputProps = {
  highlighted?: boolean;
  disabled?: boolean;
};

export const Input = styled.input.attrs({
  autoComplete: 'off',
  spellCheck: false,
})`
  background-color: var(
    ${({ highlighted, disabled }: InputProps) =>
      disabled
        ? '--input-disabled-color'
        : highlighted
        ? '--input-highlighted-color'
        : '--input-color'}
  );
  color: var(--input-text-color);
  border: 0;
  margin: 0;
  padding: ${0.25 * lineHeight}px ${0.5 * lineHeight}px;
  -webkit-appearance: none;
  border-radius: 0;
  height: ${1.5 * lineHeight}px;
  width: ${inputWidth}px;
  display: block;
  position: relative;

  &[type='checkbox'],
  &[type='radio'] {
    width: ${1.5 * lineHeight}px;
    display: inline-block;
  }
  &[type='radio'] {
    border-radius: ${0.75 * lineHeight}px;
  }

  &:checked:after {
    content: '';
    position: absolute;
    top: ${lineHeight / 2}px;
    left: ${lineHeight / 2}px;
    width: ${lineHeight / 2}px;
    height: ${lineHeight / 2}px;
    background: var(--input-text-color);
  }
  &[type='radio']:checked:after {
    border-radius: ${lineHeight / 4}px;
  }

  & option {
    font-family: 'Mono', sans-serif;
  }
`;
